export default class I18nKey {
  constructor(key, noItems) {
    this.key = key;
    this.noItems = noItems;
  }
}
